





















import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { CheckBoxItem } from "../../../../domain/document/items";
import { CheckStyleKinds, Point } from "../../../../domain/drawing";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { CheckBoxObjectStyleReader } from "../styleReaders";
import {
  StyledCheckEditableObjectMixin
} from "./mixins";

@Component({
})
export default class CheckBoxObject extends Mixins(
  StyledCheckEditableObjectMixin
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new CheckBoxObjectStyleReader(configuration.style.document.editor.objects.checkBox);
  }

  editingSource: CheckBoxItem;

  get checkedPoints(): Point[] {
    return [
      new Point(this.width * 0.2, this.height * 0.5),
      new Point(this.width * 0.5, this.height * 0.85),
      new Point(this.width * 0.85, this.height * 0.1),
    ];
  }

  get checkedPointsAsString(): string {
    return Enumerable.from(this.checkedPoints)
      .select(p => p.x + " " + p.y)
      .toArray()
      .join(" ");
  }

  get isFillStyle(): boolean {
    return this.editingSource.checkStyle === CheckStyleKinds.Fill;
  }
}
